import React from 'react';
import styles from './CheckboxWithTerms.module.scss';

interface Props {
  checked: boolean;
  setChecked: (checked: boolean) => void;
  terms: string;
  legalInfo?: JSX.Element;
}

export const CheckboxWithTerms: React.FC<Props> = ({ checked, setChecked, legalInfo, terms }) => {
  return (
    <div className={styles.checkboxWrapper}>
      <div
        role="button"
        tabIndex={0}
        onKeyDown={(e) => onCheckboxKeyDown(e, () => setChecked(!checked))}
        onClick={() => setChecked(!checked)}
        aria-label="Accept terms"
      >
        <input type="checkbox" checked={checked} tabIndex={-1} />
        <span>{terms}</span>
      </div>
      {legalInfo && <span className={styles.inputLegal}>{legalInfo}</span>}
    </div>
  );
};

const onCheckboxKeyDown = (e: React.KeyboardEvent<HTMLDivElement>, callback: () => void) => {
  if (e.key === ' ' || e.key === 'Enter') {
    e.preventDefault();
    callback();
  }
};

export default CheckboxWithTerms;
